import React, { Component } from "react"

export default class Getgot extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">GetGot</p>
            <p className="portdesctext">A online platform to aggregate results from select second hand luxury fashion websites by brand. Inspired by nights lost accelerating arthritis trying to gather stock for Cut Thwice & a reason to learn Django.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://github.com/ternlef11/getgot" target="_blank" rel="noopener noreferrer"><p className="linktext">Repo</p></a>
        </div>
      </div>
  )
}
}

